import { render, staticRenderFns } from "./ServiceArea.vue?vue&type=template&id=180f58fc&"
import script from "./ServiceArea.vue?vue&type=script&lang=js&"
export * from "./ServiceArea.vue?vue&type=script&lang=js&"
import style0 from "./ServiceArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports